require('jquery-duration-picker/dist/jquery-duration-picker.min.js');

$.timeDurationPicker.langs = {
    en: $.timeDurationPicker.langs.en_US,
    el: {
        years: "Χρόνια",
        months: "Μήνες",
        days: "Μέρες",
        hours: "Ώρες",
        minutes: "Λεπτά",
        seconds: "Δευτερόλεπτα",
        and: "και",
        button_ok: "ΟΚ",
        units: {
            year: {
                one: "χρόνος",
                other: "χρόνια"
            },
            month: {
                one: "μήνας",
                other: "μήνες"
            },
            day: {
                one: "μέρα",
                other: "μέρες"
            },
            hour: {
                one: "ώρα",
                other: "ώρες"
            },
            minute: {
                one: "λεπτό",
                other: "λεπτά"
            },
            second: {
                one: "δευτερόλεπτο",
                other: "δευτερόλεπτα"
            }
        }
    }
};

$.timeDurationPicker.i18n.pluralRules = {
    en: function (count) {
        return parseInt(count) === 1 ? "one" : "other";
    },
    el: function (count) {
        return parseInt(count) === 1 ? "one" : "other";
    }
};

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

$.timeDurationPicker.delayConvertToSeconds = function (delay, timeInterval) {
    let delayWithSeconds;
    if (timeInterval === "DAYS") {
        delayWithSeconds = delay * DAY;
    } else if (timeInterval === "HOURS") {
        delayWithSeconds = delay * HOUR;
    } else if (timeInterval === "MINUTES") {
        delayWithSeconds = delay * MINUTE;
    } else if (timeInterval === "WEEKS") {
        delayWithSeconds = delay * WEEK;
    } else if (timeInterval === "SECONDS") {
        delayWithSeconds = delay;
    }
    return delayWithSeconds;
};
